angular.module('cfn').factory('seedPlanningSummaryModel', function() {
  return {
    getSummary: getSummary,
    getByFarmByCropByFields: getByFarmByCropByFields
  };

  /*
     * Public
     */
  function getSummary(cols, rows) {
    var summary = [];
    _(cols).each(function(seedColItem, seedIndex) {
      var summedArea = sumArea(seedIndex, rows);
      var averagedSeedStrength = averageSeedStrength(seedIndex, rows);
      var summedSeed = sumSeed(seedIndex, rows);
      var warningsAndNotices = getWarningsAndNotices(seedIndex, rows);

      summary.push({
        seedName: seedColItem.name,
        sumArea: summedArea,
        seedUnit: seedColItem.seedUnit,
        averageSeedStrength: averagedSeedStrength.averageSeedStrength, // flächengewichteter Durchschnitt
        sumSeed: summedSeed, // Gesamte benötigte Menge der Sorte in
        // der gewählten Einheit der Sorteplanung (Tausendkörner bei
        // Körner/m² oder kg bei kg/ha)
        warningsAndNotices: warningsAndNotices
      });
    });

    return summary;
  }

  /*
     * Private
     */
  function sumArea(seedIndex, rows) {
    return _(rows).reduce(function(sum, item) {
      if (checkIfSeedAreaIsNull(item.seeds[seedIndex])) {
        return sum;
      } else {
        return sum + item.seeds[seedIndex].plannedArea;
      }
    }, 0);
  }

  function averageSeedStrength(seedIndex, rows) {
    var countNullSeedStrengths = 0,
      countNullAreas = 0,
      summedAreaWithoutNulls = _(rows).reduce(function(sum, item) {
        if (checkIfSeedStrengthIsNull(item.seeds[seedIndex])) {
          countNullSeedStrengths++;
          return sum;
        } else if (checkIfSeedAreaIsNull(item.seeds[seedIndex])) {
          countNullAreas++;
          return sum;
        } else {
          return sum + item.seeds[seedIndex].plannedArea;
        }
      }, 0),
      areaRatios = _(rows).map(function(item) {
        var areaIsZeroish =
          checkIfSeedAreaIsNull(item.seeds[seedIndex]) ||
          summedAreaWithoutNulls === 0;

        if (areaIsZeroish) {
          return 0;
        } else {
          return item.seeds[seedIndex].plannedArea / summedAreaWithoutNulls;
        }
      }),
      ratioTimesSeedStrength = _(rows).map(function(item, index) {
        if (checkIfSeedStrengthIsNull(item.seeds[seedIndex])) {
          return 0;
        } else {
          return areaRatios[index] * item.seeds[seedIndex].seedStrength;
        }
      }),
      sumUpRatioedSeedStrengths = _(ratioTimesSeedStrength).reduce(function(
        sum,
        item
      ) {
        return sum + item;
      },
      0);

    return {
      averageSeedStrength: sumUpRatioedSeedStrengths,
      countNullSeedStrengths: countNullSeedStrengths,

      summedAreaWithoutNulls: summedAreaWithoutNulls,
      areaRatios: areaRatios,
      ratioTimesSeedStrength: ratioTimesSeedStrength,
      sumUpRatioedSeedStrengths: sumUpRatioedSeedStrengths
    };

    /*
        return _(rows).reduce( function (sum, item) {
            return sum += item.seeds[seedIndex].plannedArea;
        }, 0);;
        */
  }

  function sumSeed(seedIndex, rows) {
    return _(rows).reduce(function(sum, item) {
      if (checkIfSeedStrengthIsNull(item.seeds[seedIndex])) {
        return sum;
      } else if (checkIfSeedAreaIsNull(item.seeds[seedIndex])) {
        return sum;
      } else {
        return (
          sum +
          item.seeds[seedIndex].plannedArea * item.seeds[seedIndex].seedStrength
        );
      }
    }, 0);
  }

  function getWarningsAndNotices(seedIndex, rows) {
    var warnings = {
      seedStrengthMissing: {
        name: 'seedStrengthMissing',
        condition: function(seedItem) {
          return (
            checkIfSeedStrengthIsNull(seedItem) &&
            !checkIfSeedAreaIsNull(seedItem)
          );
        }
      },
      areaMissing: {
        name: 'areaMissing',
        condition: function(seedItem) {
          return (
            !checkIfSeedStrengthIsNull(seedItem) &&
            checkIfSeedAreaIsNull(seedItem)
          );
        }
      }
    };
    var resultWarnings = [];

    _(rows).each(function(item) {
      _(warnings).each(function(warning, i) {
        if (warning.condition(item.seeds[seedIndex]) === true) {
          resultWarnings[warning.name] = warning.name;
        }
      });
    });

    return resultWarnings;
  }

  function getByFarmByCropByFields(farms, seedCol, rows) {
    function addThisUp(key) {
      return function(memoTotal, val) {
        if (key) {
          return memoTotal + deepGet(val, key);
        } else {
          return memoTotal + val;
        }
      };
    }

    return _(rows)
      .chain()
      .reduce(function(o, field) {
        // build structure for object (byFarm - byCrop - byField)
        var seedId, farmId, rowId;
        _(field.seeds).each(function(seed, counter) {
          /*
                    if (!field.plannedArea || !seed.plannedArea) {
                        return;
                    }
                    */

          seedId = counter;
          farmId = field.field.farmId;
          // uniq and alphabetic sorted
          rowId = field.field.name.toLowerCase() + field.field.id;

          o[farmId] = o[farmId] || {
            plannedAreaTotal: 0,
            fieldAreaTotal: 0
          };
          o[farmId].seeds = o[farmId].seeds || {};
          o[farmId].seeds[seedId] = o[farmId].seeds[seedId] || {
            plannedAreaTotal: 0,
            fieldAreaTotal: 0,
            seedStrengthTotal: 0,
            seedStrengthAverage: 0,
            seedAmountTotal: 0
          };
          o[farmId].seeds[seedId].plannedFields =
            o[farmId].seeds[seedId].plannedFields || {};
          o[farmId].seeds[seedId].plannedFields[rowId] = {
            field: field.field,
            planned: {
              plannedArea: seed.plannedArea,
              seedStrength: seed.seedStrength,
              seedAmount: seed.plannedArea * seed.seedStrength,
              seedUnit: seedCol[counter].seedUnit
            }
          };
          o[farmId].plannedAreaTotal += seed.plannedArea;
          o[farmId].seeds[seedId].plannedAreaTotal += seed.plannedArea;
          o[farmId].seeds[seedId].fieldAreaTotal += seed.plannedArea !== null && seed.seedStrength !== null ? field.field.farmedArea : 0;
          o[farmId].seeds[seedId].seedStrengthTotal +=
            o[farmId].seeds[seedId].plannedFields[rowId].planned.seedStrength;
          o[farmId].seeds[seedId].seedStrengthAverage = averageSeedStrength(
            counter,
            rows
          ).averageSeedStrength;
          o[farmId].seeds[seedId].seedAmountTotal +=
            o[farmId].seeds[seedId].plannedFields[rowId].planned.seedAmount;
          if (!o[farmId].seeds[seedId].seedUnit) {
            o[farmId].seeds[seedId].seedUnit =
              o[farmId].seeds[seedId].plannedFields[rowId].planned.seedUnit;
          }

          o[farmId].seeds[seedId].seed = seedCol[counter];
          o[farmId].farmName = farms[farmId] ? farms[farmId].name : '';
          o[farmId].fieldAreaTotal = farms[farmId]
            ? farms[farmId].farmableArea
            : 0;
        });

        return o;
      }, {})
      .each(function(farm) {
        if (farm.seeds) {
          _.each(farm.seeds, function(seedSummary) {
            seedSummary.plannedAreaRatio =
              seedSummary.plannedAreaTotal / farm.plannedAreaTotal;
          });
        }
      })
      .value();
  }

  /*
     * Helpers
     */

  function checkIfSeedStrengthIsNull(seed) {
    return _(seed.seedStrength).isNull() || _(seed.seedStrength).isUndefined();
  }

  function checkIfSeedAreaIsNull(seed) {
    return _(seed.plannedArea).isNull() || _(seed.plannedArea).isUndefined();
  }
});
